import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { 
  Heart, 
  LayoutDashboard, 
  ClipboardList, 
  Calendar, 
  FileText, 
  Settings, 
  LogOut,
  X 
} from "lucide-react";
import { useAuth } from "../context/AuthContext";
import "./PatientSidebar.css";

const PatientSidebar = ({ toggleSidebar }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const location = useLocation();
  const { logout } = useAuth();

  const navLinks = [
    { path: "/dashboard/patient", icon: LayoutDashboard, label: "Dashboard" },
    { path: "/dashboard/patient/vitals-history", icon: ClipboardList, label: "Vitals History" },
    { path: "/dashboard/patient/appointments", icon: Calendar, label: "Appointments" },
    { path: "/dashboard/patient/records", icon: FileText, label: "Medical Records" },
    { path: "/dashboard/patient/settings", icon: Settings, label: "Settings" }
  ];

  return (
    <aside className={`dashboard-sidebar ${isCollapsed ? "collapsed" : ""}`}>
      <div className="sidebar-brand">
        <div className="brand-toggle-wrapper" onClick={() => setIsCollapsed(!isCollapsed)}>
          <div className="brand-logo">
            <Heart size={20} fill="currentColor" />
          </div>
          <div className="brand-info">
            <span className="brand-name">Medico.in</span>
            <span className="brand-tag">Healthcare Monitoring</span>
          </div>
        </div>
        
        {/* Mobile Close Button */}
        <button className="close-sidebar-btn" onClick={toggleSidebar}>
          <X size={24} strokeWidth={2.5} />
        </button>
      </div>

      <nav className="sidebar-nav">
        {navLinks.map((link) => {
          const Icon = link.icon;
          const isActive = location.pathname === link.path;
          return (
            <Link 
              key={link.path} 
              to={link.path} 
              className={`nav-item ${isActive ? "active" : ""}`}
            >
              <Icon size={20} />
              <span>{link.label}</span>
            </Link>
          );
        })}
      </nav>

      <div className="sidebar-footer">
        <button className="logout-btn" onClick={logout} style={{ background: 'none', border: 'none', width: '100%', cursor: 'pointer', textAlign: 'left' }}>
          <LogOut size={20} />
          <span>Logout</span>
        </button>
      </div>
    </aside>
  );
};

export default PatientSidebar;
